import { isSupportedLocale } from "../env";

/** All namespaces shipped to the Mini App. Mirrors next-intl's `NS_FILES`. */
const NS_FILES = [
  "account",
  "address",
  "affiliate",
  "arrears",
  "auth",
  "beginner_guide",
  "bill",
  "business",
  "cart",
  "catalog",
  "categories",
  "common",
  "confirm_order",
  "contacts",
  "estimation",
  "favorite",
  "feature",
  "help",
  "home",
  "invite",
  "invite_commission",
  "invite_personal",
  "invite_record",
  "invite_team",
  "legal",
  "login_record",
  "manage",
  "message",
  "notice",
  "orders",
  "pay",
  "pay_choose",
  "points",
  "process",
  "product",
  "product_card",
  "profile",
  "prohibited",
  "promo",
  "rehearsal",
  "remittance_record",
  "review_consult",
  "security",
  "shipment",
  "shop",
  "shopwindow",
  "submit_parcel",
  "supplementary_payment",
  "tariffs",
  "transport",
  "transport_records",
  "transport_roam",
  "wallet",
  "warehouse",
  "withdraw",
] as const;

export async function buildI18nextResources(locale: string) {
  if (!isSupportedLocale(locale)) throw new Error(`Locale "${locale}" not in whitelist`);
  const entries = await Promise.all(
    NS_FILES.map(async (ns) => {
      try {
        const mod = await import(`../../locales/${locale}/${ns}.json`);
        return [ns, mod.default] as const;
      } catch {
        return [ns, {}] as const;
      }
    }),
  );
  return { [locale]: Object.fromEntries(entries) };
}

export const I18NEXT_NAMESPACES = NS_FILES;
